// Review Moderation Types (COMP-2)
// Backend enums are serialized as strings.

/** Reasons a user can give when reporting a review */
export type ReviewReportReason =
  | 'Spam'
  | 'Offensive'
  | 'Harassment'
  | 'OffTopic'
  | 'Other';

/** Moderation status of a review */
export type ReviewModerationStatus =
  | 'Visible'
  | 'UnderReview'
  | 'Hidden'
  | 'Removed';

/** Options for the report-review reason radio list */
export const REVIEW_REPORT_REASON_OPTIONS: Array<{
  value: ReviewReportReason;
  label: string;
  description: string;
}> = [
  { value: 'Spam', label: 'Spam', description: 'Advertising, promotions, or repetitive content' },
  { value: 'Offensive', label: 'Offensive content', description: 'Hateful, vulgar, or inappropriate language' },
  { value: 'Harassment', label: 'Harassment', description: 'Targets or bullies a person' },
  { value: 'OffTopic', label: 'Off-topic', description: 'Not about an experience with this business' },
  { value: 'Other', label: 'Other', description: 'Something else' },
];

/** POST /Reviews/{reviewId}/report request body */
export interface ReportReviewRequest {
  reason: ReviewReportReason;
  details?: string;
}

/** POST /Reviews/{reviewId}/report response */
export interface ReportReviewResponse {
  reportId: number;
  reviewModerationStatus: ReviewModerationStatus;
  escalated: boolean;
}

/** A single report attached to a review in the moderation queue */
export interface ReviewReportDto {
  id: number;
  reason: ReviewReportReason;
  details?: string;
  status: string;
  reporterName: string;
  createdAt: string;
  resolvedAt?: string;
}

/** Item returned by GET /admin/review-moderation/queue */
export interface ReviewModerationQueueItem {
  reviewId: number;
  rating: number;
  reviewText: string;
  createdAt: string;
  authorUserId: string;
  authorName: string;
  barbershopId: number;
  barbershopName: string;
  barberId?: number;
  barberName?: string;
  moderationStatus: ReviewModerationStatus;
  moderationReason?: string;
  moderatedAt?: string;
  pendingReportCount: number;
  totalReportCount: number;
  /** Report counts keyed by reason, e.g. { Spam: 2 } */
  reasonCounts: Partial<Record<ReviewReportReason, number>>;
  reports: ReviewReportDto[];
}

/** Response from hide / restore / remove moderation actions */
export interface ReviewModerationActionResponse {
  reviewId: number;
  moderationStatus: ReviewModerationStatus;
  resolvedReportCount: number;
}

/** Query params for the admin moderation queue */
export interface ReviewModerationQueueParams {
  /** Omit for the triage view (pending reports or UnderReview) */
  status?: ReviewModerationStatus;
  page?: number;
  pageSize?: number;
}
